import { Button } from '@mui/material';
import colors from '../../../../scss/colors';

export default function TextButton({ children, clickHandler }) {
  return (
    <Button
      variant="text"
      style={{ cursor: 'pointer' }}
      onClick={clickHandler}
      sx={{
        textDecoration: 'underline',
        textTransform: 'none',
        marginTop: '16px',
        fontSize: '1rem',
        color: colors.NAVY_BLUE,
        '&:hover': { textDecoration: 'underline', background: 'none' }
      }}
    >
      {children}
    </Button>
  );
}
